import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5frn60f0tcnoht87230', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setSubmitStatus('idle'), 5000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section id="contact" className="bg-[#f8f8f6] py-40">
      <div className="max-w-[1280px] mx-auto px-20">
        <div className="flex gap-20">
          <div className="w-[35%]">
            <h2 className="text-5xl font-bold text-[#1a1a1a] mb-12">
              Get In Touch
            </h2>

            <div className="space-y-10">
              <div>
                <div className="text-xs font-bold text-[#666666] tracking-[3px] uppercase mb-4">
                  EMAIL
                </div>
                <a 
                  href="mailto:contact@saidltda.com" 
                  className="text-lg text-[#1a1a1a] hover:text-[#0066ff] hover:underline transition-colors"
                >
                  contact@saidltda.com
                </a>
              </div>

              <div>
                <div className="text-xs font-bold text-[#666666] tracking-[3px] uppercase mb-4">
                  PHONE
                </div>
                <a 
                  href="tel:+16604933932" 
                  className="text-lg text-[#1a1a1a] hover:text-[#0066ff] hover:underline transition-colors"
                >
                  +1 6604933932
                </a>
              </div>

              <div>
                <div className="text-xs font-bold text-[#666666] tracking-[3px] uppercase mb-4">
                  ADDRESS
                </div>
                <div className="text-base text-[#1a1a1a] leading-relaxed">
                  <div>CALLE 12 N 27 62</div>
                  <div>YOPAL, 850001</div>
                  <div>COLOMBIA</div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-[65%] pl-12">
            <form id="contact-form" onSubmit={handleSubmit} data-readdy-form className="space-y-6">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
                className="w-full h-14 px-6 bg-[#ececec] rounded-lg border border-transparent focus:border-[#0066ff] focus:outline-none text-base text-[#1a1a1a] placeholder-[#999999] transition-colors"
              />

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
                className="w-full h-14 px-6 bg-[#ececec] rounded-lg border border-transparent focus:border-[#0066ff] focus:outline-none text-base text-[#1a1a1a] placeholder-[#999999] transition-colors"
              />

              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Subject"
                required
                className="w-full h-14 px-6 bg-[#ececec] rounded-lg border border-transparent focus:border-[#0066ff] focus:outline-none text-base text-[#1a1a1a] placeholder-[#999999] transition-colors"
              />

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                required
                maxLength={500}
                rows={6}
                className="w-full px-6 py-4 bg-[#ececec] rounded-lg border border-transparent focus:border-[#0066ff] focus:outline-none text-base text-[#1a1a1a] placeholder-[#999999] resize-none transition-colors"
              />

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full h-14 bg-[#0066ff] text-white rounded-full text-base font-medium hover:shadow-[0_0_30px_rgba(0,102,255,0.5)] transition-all duration-300 hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 whitespace-nowrap"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
                <i className="ri-arrow-right-line text-xl"></i>
              </button>

              {submitStatus === 'success' && (
                <div className="text-center text-green-600 font-medium">
                  Message sent successfully! We'll get back to you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="text-center text-red-600 font-medium">
                  Failed to send message. Please try again.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
